import React from 'react'
import './SingleClick.scss'

const SingleClick = props => {

    // TODO figure out how event handling is going to work for failing - WarningToast needs to be devd and placed in component tree

    const onFail = (e) => {
        alert('fail')
    }

    const onSuccess = (e) => {
        // alert('win')
        props.onGestureComplete()
    }


    return (
        <div className={`SingleClick`}>
            <div className={`fail-detector`} onClick={(e) => onFail(e)}></div>
            <div className={`hotspot`}
                style={
                    {
                        top:parseInt(props.position.top),
                        left:parseInt(props.position.left),
                        width:parseInt(props.position.width),
                        height:parseInt(props.position.height),
                    }
                }
                onClick={(e)=>onSuccess(e)}
            ></div>
        </div>
    )
}

export default SingleClick